export default "__VITE_ASSET__BJLkK42b__"